import { defineCustomElement } from '@tyler-components-web/core';
import { RippleComponent } from './ripple';
export * from './ripple-adapter';
export * from './ripple-constants';
export * from './ripple-foundation';
export * from './ripple';
export function defineRippleComponent() {
    defineCustomElement(RippleComponent);
}
